// third-party
import { FormattedMessage } from "react-intl";

// assets
import { ProfileCircle } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  widgets: ProfileCircle,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const cloudViewUser: NavItemType = {
  id: "group-cloudviewuser",
  title: <FormattedMessage id="page.menu_items_profile_label" />,
  icon: icons.widgets,
  type: "group",
  children: [
    {
      id: "group-cloudviewuser",
      title: <FormattedMessage id="page.menu_items_profile_label" />,
      type: "collapse",
      icon: icons.widgets,
      children: [
        {
          id: "profile-details",
          title: (
            <FormattedMessage id="page.menu_items_profile_details_label" />
          ),
          type: "item",
          url: "/user-details",
        },
      ],
    },
  ],
};

export default cloudViewUser;
